export default __webpack_public_path__ + "static/media/lock.621807a5.png";